/* eslint-disable import/prefer-default-export */
import { Button, Col, Empty, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NewsPost } from 'apollo/types';
import LoadingModal from 'components/generalUI/LoadingModal';
import { InformationCard } from 'components/generalUI/InformationCard';
import useListNewsPostsQuery from 'apollo/resolvers/newsPosts/list';
import styles from './NewsPosts.module.scss';
import { Pagination } from './types';
import { useNewsPostsViewModel } from './newsPosts.viewModel';

export const NewsPosts = () => {
  const { t, i18n } = useTranslation();

  const pageSize = 6;
  const { onSeeMoreButtonClick } = useNewsPostsViewModel();
  const [newsPosts, setNewsPosts] = useState<NewsPost[]>([]);
  const [pagination, setPagination] = useState<Pagination>();
  const [count, setCount] = useState<number>(0);

  const { data, loading } = useListNewsPostsQuery(pagination);

  useEffect(() => {
    if (!data) {
      return;
    }
    const { count: newsPostsCount, newsPosts: fetchedNewsPosts } = data.listNewsPosts;
    setCount(newsPostsCount);
    setNewsPosts((currentNewsPosts) =>
      pagination?.page === 1
        ? fetchedNewsPosts
        : [...currentNewsPosts, ...fetchedNewsPosts]
    );
  }, [data]);

  useEffect(() => {
    setPagination({
      page: 1,
      pageSize,
    });
  }, [i18n.language]);

  return (
    <>
      <LoadingModal visible={loading} />
      {newsPosts && pagination && newsPosts.length > 0 ? (
        <>
          <Row justify="center" gutter={{ sm: 10, md: 15, xl: 20 }}>
            {newsPosts.map((newsPost) => {
              return (
                <Col
                  key={newsPost.id}
                  className={styles.InformationCardColumn}
                  xs={24}
                  sm={12}
                  xl={8}
                >
                  <InformationCard
                    title={newsPost.title}
                    id={newsPost.id}
                    imageUrl={newsPost.coverImage?.url}
                    featured={newsPost.featured}
                    isProgram={false}
                    color={newsPost.featured ? 'green' : undefined}
                  />
                </Col>
              );
            })}
          </Row>
          {newsPosts.length < count && (
            <Row justify="center">
              <Col>
                <Button
                  className={styles.SeeMoreButton}
                  type="ghost"
                  onClick={() => onSeeMoreButtonClick(pagination, setPagination)}
                >
                  {t('pages.news.list.seeMore')}
                </Button>
              </Col>
            </Row>
          )}
        </>
      ) : (
        <Row justify="center">
          <Col>
            <Empty />
          </Col>
        </Row>
      )}
    </>
  );
};
